export const styles = {
  margin: 10,
  width: "280px",
  background: "#fff",
};
